/**
 * MobileMenuWrapper.jsx
 * Created by michaelbray on 5/7/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import MobileMenu from './MobileMenu';

import { ACCOUNT_PROPS, CART_PROPS } from '../constants';

const propTypes = {
    showMobileMenu: PropTypes.bool,
    clickedMobileMenuButton: PropTypes.func,
    logout: PropTypes.func,
    cart: CART_PROPS,
    auth: ACCOUNT_PROPS
};

const defaultProps = {
    showMobileMenu: false,
    cart: {},
    auth: {
        account: {
            account: {}
        }
    }
};

export default class MobileMenuWrapper extends React.Component {
    render() {
        let account = null;
        if (this.props.auth.account) {
            account = this.props.auth.account.account;
        }

        return (
            <div className="nav-mobile-menu-wrapper">
                <TransitionGroup>
                    {this.props.showMobileMenu && (
                        <CSSTransition
                            in={this.props.showMobileMenu}
                            classNames="mobile-menu-slide"
                            timeout={300}>
                            <MobileMenu
                                clickedMobileMenuButton={this.props.clickedMobileMenuButton}
                                logout={this.props.logout}
                                cart={this.props.cart}
                                account={account} />
                        </CSSTransition>
                    )}
                </TransitionGroup>
            </div>
        );
    }
}

MobileMenuWrapper.propTypes = propTypes;
MobileMenuWrapper.defaultProps = defaultProps;